import React, { InputHTMLAttributes } from 'react';
import CustomError from 'Douleutaras/components/CustomError/CustomError';

import './QuickCheckbox.scss';

export interface QuickCheckboxProps {
  title: string | React.ReactElement;
  id: string;
  type: string;
  name?: string;
  value?: string;
  testId?: string;
  input?: Partial<InputHTMLAttributes<HTMLInputElement>>;
  meta?: { touched: boolean, error: string, warning: string };
}

export const QuickCheckbox = ({ title, id, testId, type, input = {}, meta }: QuickCheckboxProps) => {

  return (
    <div styleName="quick-checkbox">
      <input id={id} styleName="quick-checkbox__input" type={type} {...input} />
      <label htmlFor={id} styleName="quick-checkbox__label" data-testid={testId}>
        <span styleName="quick-checkbox__title">{title}</span>
        <span className="dashicon dashicon-checkmark" styleName="quick-checkbox__icon" />
      </label>
      { meta?.touched && meta.error &&
        <CustomError>
          {meta.error}
        </CustomError>
      }
    </div>
  );
};
